module.exports = __webpack_public_path__ + "img/complate.09659d76.png";